import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("mp-token");
    if (!token) { setReady(true); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("mp-token"))
      .finally(() => setReady(true));
  }, []);

  const loginWithToken = (token, u) => {
    localStorage.setItem("mp-token", token);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("mp-token");
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, ready, loginWithToken, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
